// Section 18: Pairing policy. Free / Minimum age 18 / Minimum age 21 / Player approves (Section 15).
// Default: config.policies.defaults.pairing.
import type { Config } from '../../config';
import { noChangeCost, noProblem } from '../../core/content-helpers';
import { ageYears, peopleSorted } from '../../core/queries';
import { definePolicy, noModifiers } from '../../core/registry';

export function pairing(config: Config) {
  return definePolicy({
    id: 'pairing',
    label: 'Pairing',
    section: 'S18',
    group: 'society',
    options: ['free', 'min-18', 'min-21', 'player-approves'],
    default: config.policies.defaults.pairing,
    modifierTargets: [],
    modifiers: noModifiers,
    changeCost: noChangeCost,
    // M6: the minimum age the option sets (Section 15) and how many unpaired people reach it.
    affects(ctx, option) {
      const age = config.lifecycle.pairingMinAgeByPolicy[option];
      const unpaired = peopleSorted(ctx.state).filter(
        (p) => p.partnerId === null && ageYears(config, p.ageSeasons) >= age,
      ).length;
      const pending = ctx.state.openPrompts.filter((p) => p.kind === 'pairing').length;
      return [
        {
          key: option === 'player-approves' ? 'policy.pairing.approve' : 'policy.pairing.age',
          params: { age, unpaired, pending },
        },
      ];
    },
    validate: noProblem,
  });
}
